// 系统版本更新记录（所有租户可见，面向客户的功能迭代说明）
// 由 leanasst-web / leanasst-api 仓库提交记录按月整理，仅保留有业务意义的功能变更
// 每次发版在这里追加一条，最新版本放在最前面
export interface UpdateLogItem {
    version: string;
    date: string;
    items: string[];
}

/**
 * 条目若以'【重大】'开头，页面会显示“重大更新”标签并高亮展示。
 * 例如：'【重大】新增随机分配的任务创建模式'
 */

export const updateLogs: UpdateLogItem[] = [
    {
        version: 'v2026-08-31',
        date: '2026-08-31',
        items: [
            '【重大】新增随机分配的任务创建模式',
            '新增系统更新记录页面，可在右上角设置菜单中查看',
            '任务编辑页优化：支持修改任务名称、更换审核点模板，审核项模板任务也支持调整审核点',
            '审核点支持导出Excel',
            '完成全系统界面的英文文本适配，英文环境下的菜单、页面、提示信息全面完善，提升英文用户使用体验',
        ],
    },
    {
        version: 'v2026-08-05',
        date: '2026-08-05',
        items: [
            '修复超时提醒邮件误发给同级部门其他人的问题',
        ],
    },
    {
        version: 'v2026-07-23',
        date: '2026-07-23',
        items: [
            '【重大】新增钉钉消息通知对接',
            '修复审核团队编辑时成员丢失等问题',
        ],
    },
    {
        version: 'v2026-06-08',
        date: '2026-06-08',
        items: [
            '创建场景时自动同步消息通知的短信与企业微信模板',
        ],
    },
    {
        version: 'v2026-05-27',
        date: '2026-05-27',
        items: [
            '修复审核任务导出图片链接、审核项导入列映射等问题',
        ],
    },
    {
        version: 'v2026-04-15',
        date: '2026-04-15',
        items: [
            '仪表板和报表支持按组织架构筛选',
        ],
    },
    {
        version: 'v2026-03-11',
        date: '2026-03-11',
        items: [
            '【重大】集成企业微信：组织架构同步、消息通知分发与模板配置',
            '修复审核时过滤禁用审核项的问题',
        ],
    },
    {
        version: 'v2026-02-27',
        date: '2026-02-27',
        items: [
            '优化审核任务页面的团队任务显示，修复审核团队名称显示为空的问题',
        ],
    },
    {
        version: 'v2026-01-20',
        date: '2026-01-20',
        items: [
            '登录页新增网络安全备案信息',
            '取消问题修改限制',
        ],
    },
    {
        version: 'v2025-12-30',
        date: '2025-12-30',
        items: [
            '新增多项问题配置项：问题原因分析必填、提交时必须包含5S、审核时必须发现问题等',
            '问题分类支持配置修改时间，并自动带出计划完成时间',
            '新增问题原因字段（含App端）',
            '新增klt短信对接',
            '问题管理页面体验优化',
            '修复员工月视图显示与导出等问题',
        ],
    },
    {
        version: 'v2025-11-07',
        date: '2025-11-07',
        items: [
            '新增配置项：负责人/责任人可关闭问题',
            '新增问题进度更新并直接关闭',
            '审核任务新增审核团队筛选，任务可标记是否团队任务',
            '修复审核项、报表显示等问题',
        ],
    },
    {
        version: 'v2025-10-31',
        date: '2025-10-31',
        items: [
            '【重大】新增审核团队功能及审核团队月视图',
            '审核点模板支持限制生成任务时间',
            '问题管理支持按组织架构筛选',
        ],
    },
    {
        version: 'v2025-09-17',
        date: '2025-09-17',
        items: [
            '新增任务完成功能',
            'Web后台修改问题时可选全部状态，发现人可关闭问题、更新进度',
            '优化问题提交时的拍照体验',
        ],
    },
    {
        version: 'v2025-08-26',
        date: '2025-08-26',
        items: [
            '【重大】新增域用户登录',
            '新增任务完成功能',
            '提交即时问题时审核点、责任人、分类、描述、拍照均可配置必填',
            '视频时长与分辨率设置改为租户级',
        ],
    },
    {
        version: 'v2025-07-31',
        date: '2025-07-31',
        items: [
            '新增变更审核人功能',
            '新增登录二次验证配置项',
            '优化人员审核记录统计导出',
        ],
    },
    {
        version: 'v2025-05-29',
        date: '2025-05-29',
        items: [
            '问题管理导出增加字段',
            '修复问题查看中改正措施字段显示的问题',
        ],
    },
    {
        version: 'v2025-04-29',
        date: '2025-04-29',
        items: [
            '审核任务支持按计划/实际开始/实际结束日期排序',
            '修复人员月视图显示等若干问题',
        ],
    },
    {
        version: 'v2025-03-05',
        date: '2025-03-05',
        items: [
            '新增责任人问题统计',
        ],
    },
    {
        version: 'v2025-02-14',
        date: '2025-02-14',
        items: [
            '新增责任人问题数量统计报表',
        ],
    },
    {
        version: 'v2025-01-13',
        date: '2025-01-13',
        items: [
            '工作台：问题区域Top10点击弹窗增加时间传参',
        ],
    },
    {
        version: 'v2024-08-29',
        date: '2024-08-29',
        items: [
            '问题负责人是否必填支持配置',
            '数据维护页面新增导入导出功能',
            '用户层级支持配置是否在看板显示',
            '数据管理与LPA看板任务列表超期任务标红显示',
        ],
    },
    {
        version: 'v2024-07-31',
        date: '2024-07-31',
        items: [
            '新增任务转办开关配置',
            '审核点/审核任务跳过时支持填写跳过原因',
            '问题导出新增审核项类型字段',
            '优化部门隐患发现数量、隐患关闭率等隐患系列报表，数据维护支持隐患报表目标值',
        ],
    },
    {
        version: 'v2024-06-25',
        date: '2024-06-25',
        items: [
            '新增4个安全隐患模块报表',
            '北京LPA看板推出深色版本',
            '组织架构支持匿名可见设置',
            '新增阿里云邮箱推送配置项',
            '新增问题编辑必填项配置',
        ],
    },
    {
        version: 'v2024-05-30',
        date: '2024-05-30',
        items: [
            '【重大】新增安全隐患模块及隐患检查功能',
            '新增北京看板',
            'K1看板优化：图表数值显示、中英文对照、柱状图排序与配色',
            '问题提交支持限制配置',
            '优化计划完成率计算逻辑',
            '修复LPA看板自动刷新等问题',
        ],
    },
    {
        version: 'v2024-04-18',
        date: '2024-04-18',
        items: [
            '新增K1看板',
            'LPA看板打开默认全屏铺满，F11放大等比例缩放',
            '问题列表新增计划开始时间，详情新增实际开始时间，问题关闭记录关闭时间',
            '审核记录新增跳过筛选，App跳过支持填写原因',
            '修复LPA看板部门符合率报表等问题',
        ],
    },
    {
        version: 'v2024-03-28',
        date: '2024-03-28',
        items: [
            '优化LPA看板审核任务展示',
        ],
    },
    {
        version: 'v2024-02-29',
        date: '2024-02-29',
        items: [
            '【重大】审核任务详情支持上传视频，审核记录可查看视频',
            '问题时间字段支持配置必填',
            '新增审核描述字段与措施录入时间（用于判断是否24小时内采取措施）',
            '重复问题关闭率支持点击关闭数量查看问题清单',
            '部门报表新增部门归属功能',
            '修复LPA看板、30天未关闭统计等显示问题',
        ],
    },
    {
        version: 'v2024-01-30',
        date: '2024-01-30',
        items: [
            '新增上传视频功能及视频拍摄参数配置',
            '计划完成率只统计“计划”任务，不含“走动检查”',
            '员工月视图支持配置是否显示审核模板',
            '审核记录新增人员筛选',
            '新增禁止从相册上传图片的设置',
        ],
    },
    {
        version: 'v2023-12-12',
        date: '2023-12-12',
        items: [
            '修复24小时、30天统计的显示逻辑问题',
        ],
    },
    {
        version: 'v2023-11-12',
        date: '2023-11-12',
        items: [
            '部门报表新增部门统计归属功能，可按归属部门分组统计',
            '天津看板部门符合率报表改为按审核点分组',
            '问题列表与导出信息保持一致',
        ],
    },
    {
        version: 'v2023-10-31',
        date: '2023-10-31',
        items: [
            'LPA看板支持数据自动更新',
            '新增部门统计设置开关',
        ],
    },
    {
        version: 'v2023-09-28',
        date: '2023-09-28',
        items: [
            '新增佛山看板',
            '新增审核项跳过功能',
            '新增层级报表和责任部门统计报表',
            '审核任务新增任务升级功能、短信提醒及是否抄送上级设置',
            '问题导出新增是否重复发生、24小时内遏制措施、超期未关闭等字段',
            '审核任务支持用户层级筛选，用户层级默认按层级排序',
            '审核任务列表支持显示扩展字段',
            '邮件、消息、短信模板支持配置租户和场景名',
            '新增短信模板开关与启用设置',
            '修改计划时间落在时间范围内时，任务自动回到待办',
            '修复短信发送、审核记录筛选等若干问题',
        ],
    },
    {
        version: 'v2023-08-31',
        date: '2023-08-31',
        items: [
            '【重大】新增短信通知功能：短信配置页面与推送模板',
            'LPA看板新增数据维护页面',
            '审核任务新增休息功能与休息标签',
            '新增数据设置页面',
            '问题列表新增责任人筛选，问题管理导出新增负责人筛选',
            '审核模板复制时自动添加“副本”后缀',
            '优化App审核气泡与角标显示',
            '修复短信通知、邮件抄送等若干问题',
        ],
    },
    {
        version: 'v2023-07-27',
        date: '2023-07-27',
        items: [
            '新增北京麦格纳报表',
            '审核点模板、审核项模板支持复制',
            '审核任务与月视图支持状态多选筛选',
            '员工月视图支持显示请假状态、冻结前两列',
            '工作台问题报表支持点击查看问题清单',
            '任务导入时阻止当天重复导入相同任务',
            'App问题列表新增转办人、转办时间，可查看已关闭问题',
            '账号支持仅限AD/Ldap登录设置',
            '修复看板取值、按钮权限等若干问题',
        ],
    },
    {
        version: 'v2023-06-30',
        date: '2023-06-30',
        items: [
            '【重大】新增AD/Ldap域登录方式',
            '审核项支持设置判定不合格时必须提交问题',
            '新增多项场景配置项：问题进度提醒、问题反馈按钮、不符合项分类等',
            '审核任务列表新增请假原因与描述字段，完成时未指定责任人自动记为当前操作人',
            '问题列表新增审核项类型、责任部门、组织架构筛选',
            '审核点报表统计中跳过的审核点计为已完成',
            '优化问题列表24小时、30天、6个月重复发生的判定逻辑',
            '修复审核记录、报表、App菜单等若干问题',
        ],
    },
    {
        version: 'v2023-05-31',
        date: '2023-05-31',
        items: [
            '新增审核点跳过功能',
            '审核模板修改后自动更新未开始的审核任务',
            'App问题清单新增筛选、分页与模糊搜索',
            'App创建审核任务支持发送邮件',
            '问题导出新增发现人、责任人部门字段',
            '新增场景禁用图片上传设置',
            '修复审核任务导入、审核项导入导出模板等若干问题',
        ],
    },
    {
        version: 'v2023-04-29',
        date: '2023-04-29',
        items: [
            '【重大】新增LPA看板',
            '新增账号导入、审核人导入功能',
            '问题看板新增责任人筛选，问题设置支持按场景配置',
            '组织架构下有人员时不允许删除',
            '新增是否启用上传图片设置',
            '任务报告审核记录新增实际审核人、标准值字段',
            '修复公告创建、App问题修改等若干问题',
        ],
    },
    {
        version: 'v2023-03-31',
        date: '2023-03-31',
        items: [
            '【重大】新增审核任务条码功能，含条码基础资料与模板条码字段',
            '问题图片支持按配置的图片质量上传',
            '选项列表支持快速点检与展示形式设置',
            '重复问题判定条件升级为“6个月内同一区域同一项目号同一问题序号”',
            '角色授权时Web与App菜单权限分开',
            '工作台审核任务计划报表支持自选月份范围',
        ],
    },
    {
        version: 'v2023-02-28',
        date: '2023-02-28',
        items: [
            '审核点支持图片和富文本描述',
            '审核点模板、审核项模板新增分组功能',
            '问题报表新增问题分类、问题区域饼图及TOP10',
            '问题超期提醒改为每7天提醒一次',
            '每日邮件提醒不再显示无数据项',
            'App已结束审核任务按日期倒序排列',
        ],
    },
    {
        version: 'v2023-01-17',
        date: '2023-01-17',
        items: [
            '新增审核项编码重复校验',
            '问题详情新增审核项字段，关键字搜索支持发现人、责任人',
            '审核项统计图新增审核点筛选，可按提交时间筛选',
            '报表打印优化（A3规格，最多显示8行）',
            '修复任务未自动过期等问题',
        ],
    },
    {
        version: 'v2022-12-30',
        date: '2022-12-30',
        items: [
            '【重大】新增工作台',
            '新增每日任务提醒与任务过期邮件提醒',
            '新增审核任务柱状图、审核项问题数量统计图',
            '审核任务导出分为任务导出和审核项导出',
            'App审核任务支持按全部、完成、未完成筛选',
            '月视图支持显示同一天多个相同任务',
            '提交问题时自动带出默认问题分类',
            '修复报表筛选、图片上传等若干问题',
        ],
    },
    {
        version: 'v2022-11-28',
        date: '2022-11-28',
        items: [
            '新增安全隐患模块（EHS）',
            '【重大】租户菜单支持自定义',
            '新增场景管理页面与场景复制功能',
            '新增审核项问题统计页面',
            '选择责任人、审核人改为弹窗选择',
            '问题列表新增“是否六个月内重复发生”字段与发现时间筛选',
            '新增每日App推送提醒',
            '员工月视图支持冻结表头',
        ],
    },
    {
        version: 'v2022-10-31',
        date: '2022-10-31',
        items: [
            '【重大】新增审核记录转办，转办任务可在App中接收处理',
            '审核任务支持延期完成、提前/延后设置及附件上传',
            '审核项新增选项类型、标准值、上下限、单位字段',
            '审核报告支持录入数值',
            '问题列表新增24小时、30天列及责任部门字段',
            '人员审核记录统计新增完成率与导出功能',
            '员工月视图新增组织架构、状态、人员、模板筛选',
            '修复App待办气泡、报表取值等若干问题',
        ],
    },
    {
        version: 'v2022-09-21',
        date: '2022-09-21',
        items: [
            '【重大】审核任务支持Excel导入导出',
            '新增审核结果类型自定义与审核结果校验逻辑',
            '审核项支持选项类型基础资料',
            '审核任务详情新增审核结果标准值等字段',
        ],
    },
    {
        version: 'v2022-08-31',
        date: '2022-08-31',
        items: [
            '新增每日邮件提醒',
            '新增问题修改记录与问题历史记录',
            '月视图新增问题数量统计',
            '审核点记录统计集成到审核结果汇总',
            '修复审核次数统计等若干问题',
        ],
    },
    {
        version: 'v2022-06-22',
        date: '2022-06-22',
        items: [
            '新增审核结果汇总点开查看详情和任务报表打印功能',
        ],
    },
    {
        version: 'v2022-05-31',
        date: '2022-05-31',
        items: [
            '【重大】新增审核结果汇总报表，支持图表展示与数据汇总',
            '报表支持问题描述图片缩略图点击放大',
            '审核任务新增标签字段',
        ],
    },
    {
        version: 'v2022-04-16',
        date: '2022-04-16',
        items: [
            '关闭问题时支持强制填写备注',
            '个人可设置是否接收邮件与App推送',
            '选择人员改用树形结构展示',
            '审核记录新增审核类型查看',
            '修复问题报表取值等若干问题',
        ],
    },
    {
        version: 'v2022-03-28',
        date: '2022-03-28',
        items: [
            '【重大】新增月视图',
            '【重大】新增消息推送，对接消息系统',
            '新增问题管理导出与问题报表',
            '新增问题设置功能，支持关闭问题时要求上传改善后照片',
            '新增问题关注（点星）及关注邮件通知',
            '新增全局邮件抄送',
            '问题超期提醒支持按层级',
            '新增创建问题页面',
        ],
    },
    {
        version: 'V2.0',
        date: '2022-02-11',
        items: [
            'V2.0 正式版发布',
            '审核任务列表支持字段超链接直接查看',
            '审核记录新增审核人字段',
            '优化问题看板图片显示',
            '优化登录提示与点位打卡记录页面',
        ],
    },
];
